import React, { Component } from 'react';
import { Container,Accordion,Table, Icon,Checkbox } from 'semantic-ui-react';
import { PtInput, PtSelect,PtDateInput } from '../../../grit-utilities';
import DropdownLib from '../../../DropdownLib';
import 'semantic-ui-css/semantic.min.css';
import ScrollArea from 'react-scrollbar';
import '../../../index.css';
import config from '../../../config.json';
import { Button } from '@blueprintjs/core';
import '../../../index.css';

export default class history extends Component {
    constructor(props) {
        super(props);
        console.log(this.props)       
        this.state = this.props.pointModel    
    }
    render(){
        const{activityOptions} = DropdownLib.getDropdowns().Signs_Activity
        const {reasonOptions} = DropdownLib.getDropdowns().Signs_Activity
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
               <Table celled>
                <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>SL No.</Table.HeaderCell>
                    <Table.HeaderCell>Date</Table.HeaderCell>
                    <Table.HeaderCell>Activity Type</Table.HeaderCell>
                    <Table.HeaderCell>Reason</Table.HeaderCell>           
                </Table.Row>
                </Table.Header>
                
                <Table.Body>
                    {this.state.Activity.data.map((a,i)=>{
                        
                        const newActivityDate = new Date(a.ActivityDate)
                        const showDate = new Date(newActivityDate.getTime() + newActivityDate.getTimezoneOffset() * 60000)
                        return(
                        <Table.Row key={i}>
                            <Table.Cell>{a.label}</Table.Cell>
                            <Table.Cell>{a.ActivityDate === null ? 'Not Selected' : `${showDate.getFullYear()}-${showDate.getMonth() + 1}-${showDate.getDate()}`}</Table.Cell>
                            <Table.Cell>{a.ActivityType === null ? 'Not Selected': a.ActivityType}</Table.Cell>
                            <Table.Cell>{a.ActivityReason === null ? 'Not Selected' : a.ActivityReason}</Table.Cell>
                        </Table.Row>
                        )
                    })}
                </Table.Body>
                
            </Table>
            </ScrollArea>
            </Container>
        )
    }   
    

}


// WEBPACK FOOTER //
// ./src/layers/tabs/sign/activityhistory.js